<icc-list [searchable]="true" [items]="locks"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (select)="selectLock($event)"
          [selected]="selectedLock$ | async"
></icc-list>
